import toast from "react-hot-toast";
import moment from "moment";

export function isPercentage(value) {
    // Regular expression to match a percentage value
    const percentageRegex = /^(\d+(\.\d+)?%$)|^100%$/;

    return percentageRegex.test(value);
}

export function toastSuccess(message) {
    toast.success(message);
}

export function toastError(error) {
    toast.error(error.response?.data?.message || error.response?.message || error.message);
}

export const formateDateString = (dateString, format = "ll") => {
    return moment(dateString).format(format);
}


export const formatCurrency = (input, currency = 'XOF') => {
    // Convert input to a number if it's a string
    const value = typeof input === 'string' ? parseFloat(input) : input;

    // Check if the input is a valid number
    if (isNaN(value)) {
        return '-';
    }

    const formattedCurrency = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
    }).format(value);

    return formattedCurrency;
}

export const formatPercentage = (input) => {
    // Convert input to a number if it's a string
    const value = typeof input === 'string' ? parseFloat(input) : input;

    // Check if the input is a valid number
    if (isNaN(value)) {
        return '-';
    }

    return `${value} %`;
}

/**
 * Checks if an image should be visible based on permission level and viewer relationship
 * @param {number} permissionLevel - Permission level (0=public, 1=follow list, 2=link list, 3=both, -1=none)
 * @param {boolean} isOwnProfile - Whether the viewer is the profile owner
 * @param {boolean} isFollowing - Whether the viewer is following the profile owner
 * @param {string} isLinked - Link status ("linked", "pending", "not_linked")
 * @returns {boolean} - Whether the image should be visible
 */
export const canViewImage = (permissionLevel, isOwnProfile, isFollowing, isLinked) => {
  // Always show for own profile
  if (isOwnProfile) return true;
  
  switch (permissionLevel) {
    case 0: return true; // public
    case 1: return isFollowing === true; // follow list
    case 2: return isLinked === "linked"; // link list
    case 3: return isFollowing === true && isLinked === "linked"; // both
    case -1: return false; // none
    default: return false;
  }
};

export function formatTimeAgo(date) {
  const now = new Date();
  const diffInMs = now.getTime() - date.getTime();
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
  const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));

  if (diffInDays > 0) {
    return `${diffInDays} day${diffInDays > 1 ? "s" : ""} ago`;
  } else if (diffInHours > 0) {
    return `${diffInHours} hour${diffInHours > 1 ? "s" : ""} ago`;
  } else {
    return "Just now";
  }
}